<template>
    <div class="animated fade-in">
        <h1 class="display-4 font-weight-lighter clearfix">
            <span class="float-left">Manage Product Access</span>
            <!-- <b-button-group class="float-right">
                <b-button @click="toggleAll(true)">Select All</b-button>
                <b-button @click="toggleAll(false)">Remove All</b-button>
            </b-button-group> -->
        </h1>
        <div class="my-5"></div>
        <b-card no-body>
          <b-card-header><h6 class="m-0 p-0 font-weight-bold">Pending Changes</h6></b-card-header>
          <b-card-body>
            <b-alert v-if="!updated.length" show>No changes detected yet.</b-alert>
            <b-table :items="updated" small striped>
              <template v-slot:cell(customer)="data">
                  <b>{{data.value.name}}</b>
              </template>
              <template v-slot:cell(access)="data">
                  {{ data.value ? data.value.join(', ') : 'NONE'}}
              </template>
            </b-table>
            <b-row>
              <b-col cols="9"></b-col>
              <b-col><b-overlay spinner-small :show="saving"><b-button squared variant="sf" block @click.prevent="saveChanges"><i class="fal fa-save"></i> Save</b-button></b-overlay></b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <b-table v-if="!saving" :fields="fields" :items="items" small striped>
            <template v-slot:cell(customer)="data">
                <b>{{data.value.name}}</b>
            </template>
            <template v-slot:cell()="data">
                <b-form-checkbox
                  v-model="data.item[data.field.key]"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
            </template>
        </b-table>
    </div>
</template>

<script>
  import {GREEDY_FETCH_ENTITY} from "@/store/action-types";
  import Customer from "../../models/Customer";
  import ProductType from "../../models/ProductType";

  export default {
    name: "ProductAccess",
    data() {
      return {
        loading: true,
        saving: false,
        customers: [],
        product_types: [],
        items: [],
        fields: [],
        updated: [],
      };
    },
    methods: {
      fetch() {
        this.loading = true;
        this.customers = [];
        this.product_types = [];
        this.items = [];
        this.fields = [];
        return Promise.all([
          Customer.api().fetch({limit: 9999}),
          this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: ProductType}),
        ]).then(() => {
          this.customers = Customer.query().orderBy('name').get();
          this.product_types = ProductType.all();
          this.fields = ['customer', ...this.product_types.map(pt => pt.name)];
          this.customers.forEach((customer) => {
            let types = {};
            this.product_types.forEach((product_type) => {
              types[product_type.name] = (customer.product_type_access||[]).includes(product_type.name);
            });
            this.items.push({customer, ...types});
          });
          this.loading = false;
        });
      },
      saveChanges() {
        this.saving = true;
        let requests = [];
        this.updated.forEach(i => {
          requests.push(Customer.api().update(i.customer.id, {product_type_access: i.access}));
        });
        Promise.all(requests).then(() => {
          this.fetch().then(() => {
            this.saving = false;
          });
        });
      }
    },
    watch: {
      'items': {
        handler() {
          this.updated = [];
          this.items.forEach(i=>{
            let customer = i.customer;
            let tmp = {...i};
            delete tmp.customer;
            let access = Object.keys(tmp).map(k=>[k,tmp[k]]).filter(i=>i[1]).map(i=>i[0]);
            if(JSON.stringify(customer.product_type_access) !== JSON.stringify(access)) {
              this.updated.push({customer, access});
            }
          });
        },
        deep: true
      }
    },
    mounted() {
      this.fetch();
    }
  };
</script>
